import React, { Component } from 'react';
import { Spin } from 'antd'
import Charts from './Charts';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import Filter from './Filter';
import moment from 'moment';

class HistogramBrokenLine extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            searchParams: this.props.searchParams||{},
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { searchParams } = this.state;
        const{year}=searchParams;
        // let beginDate = moment(`${moment().format('YYYY')}-1`).format('YYYY-MM');
        // let endDate = moment(`${moment().format('YYYY')}-12`).format('YYYY-MM');
        // beginDate=moment(`${moment(year).format('YYYY')}-1`).format('YYYY-MM');
        // endDate=moment(`${moment(year).format('YYYY')}-12`).format('YYYY-MM');
        this.setState({ loading: true });
        const{searchChange}=this.props;
        Fetch.post(API_URL.home.queryInvoicingChartList, {
            // beginDate:beginDate,
            // endDate:endDate,
            type:"Receive",
            year:year?year:moment().format('YYYY'),
            ...searchParams,
        }).then(res => {
            const { list } = res;
            this.setState({
                data:list,
                loading: false,
            });
            searchChange(searchParams);
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    search = () => {
        this.loadData();
    }

    render() {
        const { clientHeight,searchInfo={} } = this.props;
        const { loading,
            data
        } = this.state;
        const height = clientHeight - 72;
        const { searchParams } = this.state;
        const{year}=searchParams;
        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    searchParams={searchParams}
                    onChange={this.handleFilterChange}
                />
                <Spin spinning={loading}>
                    <Charts
                     searchParams={searchParams}
                     data={data}
                     height={height} 
                     searchInfo={searchInfo}
                     filename={`年度回款分析${year}`}
                     />
                </Spin>
            </div>
        );
    }
}

export default HistogramBrokenLine;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualPaymentCollectionAnalysis/HistogramBrokenLine/index.js